import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileTypes } from '../../models/file-type';
import { BaseComponent } from '../base/base.component';
import {
  DistributionDocument,
  DistributionDocumentState,
  DistributionJobState,
  DistributionPlaceholder
} from '../../models/distribution-doc-models';
import { Thumbnailable } from '../file-upload/thumb-nail-base.component';
import { CaseFileCategories, CaseFileCategory } from '@app/shared/models/case-file-category';

@Component({
  selector: 'distribution-list',
  templateUrl: './distribution-list.component.html',
  styleUrls: ['./distribution-list.component.scss']
})
export class DistributionListComponent extends BaseComponent implements OnInit {

  @Input()
  public jobState: DistributionJobState;

  @Input()
  public documents: DistributionDocument[];

  @Output()
  public update = new EventEmitter<DistributionDocument>();

  @Output()
  public view = new EventEmitter<Thumbnailable>();

  @Output()
  public delete = new EventEmitter<DistributionDocument>();

  public viewFileIcon = 'fa-eye';

  get DistributionDocState() {
    return DistributionDocumentState;
  }

  get DistributionJobState() {
      return DistributionJobState;
  }

  get FileTypes() {
    return FileTypes;
  }

  get CaseFileCategories() {
     return CaseFileCategories;
  }

  get CaseFileCategory() {
    return CaseFileCategory;
  }

  constructor() {
    super();
    this._idPrefix = 'distribution_list.';
  }

  public ngOnInit() {
    super.ngOnInit();
  }

  public updateDistributionDocument(doc: DistributionDocument): void {
    this.update.emit(doc);
  }

  public showFile(doc: DistributionDocument): void {
      this.view.emit(doc);
  }

  public deleteFile(doc: DistributionDocument): void {
    this.delete.emit(doc);
  }

  public asDistributionPlaceholder(doc: DistributionDocument): DistributionPlaceholder {
    return doc && doc instanceof DistributionPlaceholder && doc as DistributionPlaceholder;
  }

}
